import { Space } from 'antd';
import type { ReactNode } from 'react';

/**
 * Q-mt-2 A (founder, 2026-10-03, 1.5.0 manual pass) — the ONE placement of a submit error in every
 * E34 drawer and dialog: directly ABOVE the footer buttons, where the eye is (at the top of a long
 * drawer it went unseen). An error that was already known when the drawer opened is NOT this: it stays
 * at the top and disables the submit button.
 *
 * `errors` is whatever the footer must show above the buttons (Alerts); `children` the buttons.
 */
export const SubmitFooter = ({
  errors,
  children,
}: {
  errors?: ReactNode;
  children: ReactNode;
}) => (
  <Space direction="vertical" size="middle" style={{ width: '100%' }}>
    {errors}
    <Space style={{ display: 'flex', justifyContent: 'flex-end' }}>
      {children}
    </Space>
  </Space>
);
